import {FC, MouseEventHandler, ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import SectionHeader from 'components/SectionHeader';

type InboxSectionHeaderProps = {
    buttonOnclick: MouseEventHandler<HTMLButtonElement>;
    isButtonDisabled: boolean;
    subtitle: ReactNode;
    title: string;
};

const InboxSectionHeader: FC<InboxSectionHeaderProps> = ({
    buttonOnclick,
    isButtonDisabled = false,
    subtitle,
    title,
}) => {
    const {t} = useTranslation('Portal');

    return (
        <SectionHeader
            button={{
                disabled: isButtonDisabled,
                kind: 'secondary',
                label: t('inbox.downloadSelection'),
                onClick: buttonOnclick,
                type: 'button',
            }}
            level={1}
            subtitle={subtitle}
            title={title}
            tooltipMessage={
                isButtonDisabled
                    ? t('inbox.downloadSelectionDisabledReason')
                    : ''
            }
        />
    );
};

export default InboxSectionHeader;
